// Privremeni prekidači za UI elemente koji još nemaju backend podršku.

// Točkica "nepročitane obavijesti" na zvoncu (AppHeader mobile + PageHeader desktop). Zasad je
// čisto vizualna (Figma) — skrivena dok backend ne dobije notifikacije s brojem nepročitanih.
export const SHOW_NOTIFICATION_DOT = false;
